// extracted by mini-css-extract-plugin
export default {"trigger":"_9400m","skeleton-progress":"g7nQD"};